import '../assets/app-tailwind.css'

import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import store from './apps/store/store'
import InlineSearch from "./apps/inline-search/InlineSearch.jsx"

// Import React Apps
import './apps/product/index.jsx'
import './apps/product-tiles/index.jsx'
import './apps/cart-drawer/index.jsx'
import './apps/address-form/index.jsx'
import './apps/full-search/index.jsx'

// Components
import { setupNewsletters } from './components/Newsletter.js'
import { setupPaginations } from './components/Pagination.js'
import { setupCountrySelector } from './components/CountrySelector.js'

// Sections
import { setupHeader } from './sections/header.js'
import { setupHero } from './sections/hero.js'
import { setupCollection } from './sections/collection.js'
import { setupProduct } from './sections/product.js'
import { setupRelatedProducts } from './sections/related-products.js'
import { setupCart } from './sections/cart.js'
import { setupFlagshipHero } from './sections/flagship-hero.js'
import { setupHistory } from './sections/history.js'
import { setupAccount } from './sections/account.js'

document.addEventListener('DOMContentLoaded', () => {
  // Sections
  setupHeader()
  setupHero()
  setupCollection()
  setupProduct()
  setupRelatedProducts()
  setupCart()
  setupFlagshipHero()
  setupHistory()
  setupAccount()

  // Components
  setupNewsletters()
  setupPaginations()
  setupCountrySelector()

  // Init Search Components after setupHeader
  const searchWrappers = document.querySelectorAll('[data-megamenu-handle="search"]')
  searchWrappers.forEach((searchWrapper) => {
    const root = createRoot(searchWrapper)
    root.render(
      <Provider store={store}>
        <InlineSearch />
      </Provider>)
  })  
})